export default __webpack_public_path__ + "static/media/letter.190eb5b5.svg";